function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendarDialogIcon = function SvgCalendarDialogIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendario",
    transform: "translate(1.000000, 1.000000)",
    fill: "#3399CC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "nonzero",
    d: "M3.8125,2.0625 C4.08864237,2.0625 4.3125,2.28635763 4.3125,2.5625 C4.3125,2.80795989 4.13562484,3.01210837 3.90237563,3.05444433 L3.8125,3.0625 L1.812,3.062 L1.812,15.187 L15.187,15.187 L15.187,3.062 L13.1875,3.0625 C12.9420401,3.0625 12.7378916,2.88562484 12.6955557,2.65237563 L12.6875,2.5625 C12.6875,2.31704011 12.8643752,2.11289163 13.0976244,2.07055567 L13.1875,2.0625 L15.6875,2.0625 C15.9329599,2.0625 16.1371084,2.23937516 16.1794443,2.47262437 L16.1875,2.5625 L16.1875,15.6875 C16.1875,15.9329599 16.0106248,16.1371084 15.7773756,16.1794443 L15.6875,16.1875 L1.3125,16.1875 C1.06704011,16.1875 0.86289163,16.0106248 0.820555669,15.7773756 L0.8125,15.6875 L0.8125,2.5625 C0.8125,2.31704011 0.989375161,2.11289163 1.22262437,2.07055567 L1.3125,2.0625 L3.8125,2.0625 Z",
    id: "Stroke-3146"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "nonzero",
    d: "M5.6875,0.8125 L3.8125,0.8125 C3.53635763,0.8125 3.3125,1.03635763 3.3125,1.3125 L3.3125,3.8125 C3.3125,4.08864237 3.53635763,4.3125 3.8125,4.3125 L5.6875,4.3125 C5.96364237,4.3125 6.1875,4.08864237 6.1875,3.8125 L6.1875,1.3125 C6.1875,1.03635763 5.96364237,0.8125 5.6875,0.8125 Z M5.187,1.812 L5.187,3.312 L4.312,3.312 L4.312,1.812 L5.187,1.812 Z",
    id: "Stroke-3147"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "nonzero",
    d: "M13.1875,0.8125 L11.3125,0.8125 C11.0363576,0.8125 10.8125,1.03635763 10.8125,1.3125 L10.8125,3.8125 C10.8125,4.08864237 11.0363576,4.3125 11.3125,4.3125 L13.1875,4.3125 C13.4636424,4.3125 13.6875,4.08864237 13.6875,3.8125 L13.6875,1.3125 C13.6875,1.03635763 13.4636424,0.8125 13.1875,0.8125 Z M12.687,1.812 L12.687,3.312 L11.812,3.312 L11.812,1.812 L12.687,1.812 Z",
    id: "Stroke-3148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "nonzero",
    d: "M11.3125,2.0625 C11.5886424,2.0625 11.8125,2.28635763 11.8125,2.5625 C11.8125,2.80795989 11.6356248,3.01210837 11.4023756,3.05444433 L11.3125,3.0625 L5.6875,3.0625 C5.41135763,3.0625 5.1875,2.83864237 5.1875,2.5625 C5.1875,2.31704011 5.36437516,2.11289163 5.59762437,2.07055567 L5.6875,2.0625 L11.3125,2.0625 Z",
    id: "Stroke-3149"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "nonzero",
    d: "M15.6875,5.1875 C15.9636424,5.1875 16.1875,5.41135763 16.1875,5.6875 C16.1875,5.93295989 16.0106248,6.13710837 15.7773756,6.17944433 L15.6875,6.1875 L1.3125,6.1875 C1.03635763,6.1875 0.8125,5.96364237 0.8125,5.6875 C0.8125,5.44204011 0.989375161,5.23789163 1.22262437,5.19555567 L1.3125,5.1875 L15.6875,5.1875 Z",
    id: "Stroke-3150"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "nonzero",
    d: "M5.0625,6.4375 C5.30795989,6.4375 5.51210837,6.61437516 5.55444433,6.84762437 L5.5625,6.9375 L5.5625,14.4375 C5.5625,14.7136424 5.33864237,14.9375 5.0625,14.9375 C4.81704011,14.9375 4.61289163,14.7606248 4.57055567,14.5273756 L4.5625,14.4375 L4.5625,6.9375 C4.5625,6.66135763 4.78635763,6.4375 5.0625,6.4375 Z",
    id: "Stroke-3151"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "nonzero",
    d: "M8.5,6.4375 C8.74545989,6.4375 8.94960837,6.61437516 8.99194433,6.84762437 L9,6.9375 L9,14.4375 C9,14.7136424 8.77614237,14.9375 8.5,14.9375 C8.25454011,14.9375 8.05039163,14.7606248 8.00805567,14.5273756 L8,14.4375 L8,6.9375 C8,6.66135763 8.22385763,6.4375 8.5,6.4375 Z",
    id: "Stroke-3152"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "nonzero",
    d: "M12.5,6.4375 C12.7454599,6.4375 12.9496084,6.61437516 12.9919443,6.84762437 L13,6.9375 L13,14.4375 C13,14.7136424 12.7761424,14.9375 12.5,14.9375 C12.2545401,14.9375 12.0503916,14.7606248 12.0080557,14.5273756 L12,14.4375 L12,6.9375 C12,6.66135763 12.2238576,6.4375 12.5,6.4375 Z",
    id: "Stroke-3153"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "nonzero",
    d: "M14.4375,7.6875 C14.7136424,7.6875 14.9375,7.91135763 14.9375,8.1875 C14.9375,8.43295989 14.7606248,8.63710837 14.5273756,8.67944433 L14.4375,8.6875 L2.5625,8.6875 C2.28635763,8.6875 2.0625,8.46364237 2.0625,8.1875 C2.0625,7.94204011 2.23937516,7.73789163 2.47262437,7.69555567 L2.5625,7.6875 L14.4375,7.6875 Z",
    id: "Stroke-3154"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "nonzero",
    d: "M14.4375,10.1875 C14.7136424,10.1875 14.9375,10.4113576 14.9375,10.6875 C14.9375,10.9329599 14.7606248,11.1371084 14.5273756,11.1794443 L14.4375,11.1875 L2.5625,11.1875 C2.28635763,11.1875 2.0625,10.9636424 2.0625,10.6875 C2.0625,10.4420401 2.23937516,10.2378916 2.47262437,10.1955557 L2.5625,10.1875 L14.4375,10.1875 Z",
    id: "Stroke-3155"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "nonzero",
    d: "M14.4375,12.6875 C14.7136424,12.6875 14.9375,12.9113576 14.9375,13.1875 C14.9375,13.4329599 14.7606248,13.6371084 14.5273756,13.6794443 L14.4375,13.6875 L2.5625,13.6875 C2.28635763,13.6875 2.0625,13.4636424 2.0625,13.1875 C2.0625,12.9420401 2.23937516,12.7378916 2.47262437,12.6955557 L2.5625,12.6875 L14.4375,12.6875 Z",
    id: "Stroke-3156"
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarDialogIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar_dialog_icon.af3035b0.svg";
export { ForwardRef as ReactComponent };